import { InjectionToken } from '@angular/core';
import type { PmWorkspaceComponent } from '../../../layout/pm-workspace/pm-workspace.component';

/**
 * What the global search popup still reads from the workspace: the query, results and loading state the top bar search box drives, the keyboard highlight, and opening a result.
 * The workspace provides itself under this token. Shrinks as the shared stores are split out.
 */
export type PmShellGlobalSearchHost = Pick<
  PmWorkspaceComponent,
  | 'headerGlobalSearchActiveIndex'
  | 'headerGlobalSearchDebouncing'
  | 'headerGlobalSearchError'
  | 'headerGlobalSearchFlatResults'
  | 'headerGlobalSearchGroupedResults'
  | 'headerGlobalSearchHasSearched'
  | 'headerGlobalSearchLoading'
  | 'headerGlobalSearchModalLeftPx'
  | 'headerGlobalSearchModalWidthPx'
  | 'headerGlobalSearchQuery'
  | 'headerGlobalSearchResults'
  | 'isHeaderGlobalSearchModalOpen'
  | 'isSearchExpanded'
  | 'onHeaderGlobalSearchResultClick'
  | 'searchModuleKey'
  | 'stopProp'
>;

export const PM_SHELL_GLOBAL_SEARCH_HOST = new InjectionToken<PmShellGlobalSearchHost>('PmShellGlobalSearchHost');
